import axios from "axios";
import { headerConfig } from "../utility/RequestHeaderConfig";
import { BASE_API_URL } from "../utility/URL";



const unpaidReceiptAgainstMember = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/unpaid-receipt", data, headerConfig);
        return response;
};

const programmeReceiptPaymentSave = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "member/payment-action", data, headerConfig);
        return response;
};


const paidPaymentList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "member/payment-list", data, headerConfig);
        return response;
};


const paymentmasterDataByID = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/payment-edit", data, headerConfig);
        return response;
};

const clubPaymentmasterDataByID = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/payment-edit-club", data, headerConfig);
        return response;
};



const paymentDetailsDataByID = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/payment-details-data", data, headerConfig);
        return response;
};


const paymentPaidReceiptList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/paid-receipt", data, headerConfig);
        return response;
};

const paymentPaidUnpaidReceiptList = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "programme/paid-unpaid-receipt", data, headerConfig);
        return response;
};

const shortExcessAmount = async (data) => {
    const response = await axios
        .post(BASE_API_URL + "member/payment-short-excess", data, headerConfig);
        return response;
};


const paymentService = {
    unpaidReceiptAgainstMember,
    programmeReceiptPaymentSave,
    paidPaymentList,
    paymentmasterDataByID,
    paymentDetailsDataByID,
    paymentPaidReceiptList,
    paymentPaidUnpaidReceiptList,
    shortExcessAmount,
    clubPaymentmasterDataByID
};

export default paymentService;